module.exports = __webpack_public_path__ + "static/10-6e334019772e10a5c2e1c750fb2b1b6e.gif";